const CryptoJS = require("crypto-js");

const Security = {
    encryptContent(content){
        if (process.env.NODE_ENV === 'development'){
            return content
        }

        return CryptoJS.AES.encrypt(content, process.env.VUE_APP_AES_SECRET_KEY).toString()
    },

    decryptContent(encryptedContent){
        if (process.env.NODE_ENV === 'development'){
            return encryptedContent
        }

        if (encryptedContent != null){
            let bytes  = CryptoJS.AES.decrypt(encryptedContent, process.env.VUE_APP_AES_SECRET_KEY);
            return bytes.toString(CryptoJS.enc.Utf8)
        }

        return encryptedContent
    }
}

export default Security